import { formatWallClock, type AttendanceReportStamp } from '@wf/shared'
import { STAMP_KIND_LABEL } from '../corrections/labels'

/** Karte „Heute gestempelt" (Design 1a): eine Zeile je Buchung mit Art-Farbpunkt + Uhrzeit;
 *  entwertete bleiben durchgestrichen sichtbar (Revisionssicherheit auch in der MA-Sicht). */
export function TodayStampsCard({ stamps }: { stamps: readonly AttendanceReportStamp[] }) {
  return (
    <div className="wf-card wf-zscard">
      <div className="wf-zscard__label">Heute gestempelt</div>
      {stamps.length === 0 ? (
        <p className="muted">Noch keine Buchungen heute.</p>
      ) : (
        <ul className="wf-zsbook" aria-label="Heutige Stempelungen">
          {stamps.map((s) => (
            <li key={s.id} className={s.voided ? 'wf-zsbook__row wf-zsbook__row--void' : 'wf-zsbook__row'}>
              <span className={`wf-zsbook__dot wf-zsbook__dot--${s.kind}`} aria-hidden="true" />
              <span className="wf-zsbook__label">{STAMP_KIND_LABEL[s.kind]}</span>
              <span className="wf-mono wf-zsbook__time">{formatWallClock(s.tsMs)} Uhr</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
